import React, { useCallback, useState } from 'react';
import EmailStep from './components/EmailStep';
import NewPasswordStep from './components/NewPasswordStep';

// import { Container } from './styles';
export enum EStep {
  'email',
  'newPassword',
}

const RecoverPassword: React.FC = () => {
  const [step, setStep] = useState<EStep>(EStep.email);
  const [userEmail, setUserEmail] = useState<string>('');

  const handleNextStep = useCallback((email: string) => {
    setUserEmail(email);
    setStep(EStep.newPassword);
  }, []);

  if (step === EStep.email) {
    return <EmailStep nextStep={handleNextStep} />;
  }

  return <NewPasswordStep userEmail={userEmail} />;
};

export default RecoverPassword;
